import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProcessesProvider } from './context/ProcessesContext';
import { TrainingSocketProvider } from './context/TrainingSocketContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import LandingPage from './components/landing/LandingPage';
import SignInAuth from './pages/SignInAuth';
import SignUpAuth from './pages/SignUpAuth';
import AuthCallback from './pages/AuthCallback';
import SystemOverview from './pages/SystemOverview';
import TrainingPage from './pages/TrainingPage';
import ModelsPage from './pages/ModelsPage';
import APIPage from './pages/APIPage';
import ModelBuilder from './pages/PipelineBuilder';
import PipelineBuilderPage from './pages/PipelineBuilderPage';
import ProjectsPage from './pages/ProjectsPage';
import BillingPage from './pages/BillingPage';
import SettingsPage from './pages/SettingsPage';
import DataPage from './pages/DataPage';
import InferencePage from './pages/InferencePage';
import DataLabelingPage from './pages/DataLabelingPage';
import CommunityPage from './pages/CommunityPage';
import ProcessesPage from './pages/ProcessesPage';
import DocumentationPage from './pages/DocumentationPage';
import CodeViewerPage from './pages/CodeViewerPage';
import PendingApproval from './pages/PendingApproval';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <TrainingSocketProvider>
          <ProcessesProvider>
            <Routes>
          {/* Landing Page */}
          <Route path="/" element={<LandingPage />} />

          {/* Auth Routes */}
          <Route path="/signin" element={<SignInAuth />} />
          <Route path="/signup" element={<SignUpAuth />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/pending-approval" element={<PendingApproval />} />

          {/* Dashboard Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <SystemOverview />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/training/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <TrainingPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/training/code-viewer"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <CodeViewerPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/models"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ModelsPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/inference"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <InferencePage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/api"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <APIPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/model-builder"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ModelBuilder />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/pipeline-builder"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <PipelineBuilderPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/projects"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ProjectsPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/data/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <DataPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/data-labeling"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <DataLabelingPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/community/*"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <CommunityPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/processes"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ProcessesPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/billing"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <BillingPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/settings"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <SettingsPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/documentation"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <DocumentationPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          {/* Legacy routes for backward compatibility */}
          <Route
            path="/training"
            element={<Navigate to="/dashboard/training" replace />}
          />
        </Routes>
          </ProcessesProvider>
        </TrainingSocketProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
